var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Planification")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.jobs,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(project)",fn:function(data){return [_c('router-link',{attrs:{"to":{
					name: 'planification_job',
					params: { id: data.item._id },
				}}},[_vm._v(_vm._s(data.value))])]}},{key:"cell(nextRunAt)",fn:function(data){return [_vm._v("\n\t\t\t"+_vm._s(!data.item.repeatInterval && data.item.lockedAt === null
					? "terminé"
					: data.value)+"\n\t\t")]}}])}),_c('b-button',{on:{"click":_vm.new_job}},[_vm._v("Nouvelle planification")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }